import { render, staticRenderFns } from "./allDiscussion.vue?vue&type=template&id=1f93a5b5&scoped=true"
import script from "./allDiscussion.vue?vue&type=script&lang=js"
export * from "./allDiscussion.vue?vue&type=script&lang=js"
import style0 from "./allDiscussion.vue?vue&type=style&index=0&id=1f93a5b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93a5b5",
  null
  
)

export default component.exports